<template>
  <footer class="bg-indigo-700 text-white pt-10 pb-6">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 grid grid-cols-1 md:grid-cols-4 gap-8">
      <!-- Company Info -->
<div>
  <img  src="/WaterMark.png" alt="Company Logo" class="h-10 mb-4" />
  
  <!-- <h3 v-else class="text-xl font-bold mb-4">
    {{ $t('footer.companyTitle') }}
  </h3> -->

  <p class="text-sm text-indigo-100">
    {{ $t('footer.companyDesc') }}
  </p>
</div>

      <!-- Quick Links -->
      <div>
        <h3 class="text-xl font-bold mb-4">{{ $t('footer.quickLinks') }}</h3>
        <ul class="space-y-2 text-sm">
          <li><router-link to="/" class="hover:text-teal-300 transition-colors duration-200">{{ $t('footer.links.home') }}</router-link></li>
          <!-- <li><router-link to="/shop" class="hover:text-teal-300 transition-colors duration-200">{{ $t('footer.links.shop') }}</router-link></li> -->
          <li><router-link to="/login" class="hover:text-teal-300 transition-colors duration-200">{{ $t('footer.links.login') }}</router-link></li>
          <li><router-link to="/terms" class="hover:text-teal-300 transition-colors duration-200">{{ $t('footer.links.terms') }}</router-link></li>
          <li><router-link to="/privacy" class="hover:text-teal-300 transition-colors duration-200">{{ $t('footer.links.privacy') }}</router-link></li>
        </ul>
      </div>

      <!-- Support -->
      <div>
        <h3 class="text-xl font-bold mb-4">{{ $t('footer.support') }}</h3>
        <ul class="space-y-2 text-sm">
          <li>
            <a href="/contact" class="hover:text-teal-300 transition-colors duration-200">
              {{ $t('footer.links.contact') }}
            </a>
          </li>
          <li class="flex  gap-4"> <!-- add flex & gap -->
            <template v-for="(link, name) in socialLinks" :key="name">
              <a
                :href="link"
                target="_blank"
                class="hover:text-teal-300 transition-colors duration-200 text-xl"
              >
                <i :class="getIconClass(name)"></i>
              </a>
            </template>
          </li>
        </ul>
      </div>


      <!-- Social Icons (Top) -->
     <div>
        <h3 class="text-xl font-bold mb-4">{{ $t('footer.followUs') }}</h3>
        <div class="flex flex-row space-x-4 rtl:space-x-reverse items-center">
          <!-- Apple Store Link -->
          <a href="https://apps.apple.com/us/app/%D9%85%D9%86-%D8%A7%D9%84%D9%85%D8%A7%D9%84%D9%83-%D8%A8%D8%AF%D9%88%D9%86-%D9%88%D8%B3%D9%8A%D8%B7/id6748364359" target="_blank" rel="noopener">
            <img src="/apple.svg" alt="Apple Store" class="w-32 h-auto hover:opacity-80 transition-opacity duration-200" />
          </a>

          <!-- Google Play Link -->
          <a href="https://play.google.com/store/apps/details?id=com.geeltech.fromksa&hl=ar" target="_blank" rel="noopener">
            <img src="/google.svg" alt="Google Play" class="w-32 h-auto hover:opacity-80 transition-opacity duration-200" />
          </a>
        </div>
      </div>

    </div>

    <!-- Footer Bottom -->
    <div class="max-w-7xl mx-auto px-4 sm:px-6">
      <div class="flex flex-col md:flex-row justify-between items-center mt-10 border-t border-indigo-500 pt-4">
     <div class="text-sm text-indigo-100 mb-4 md:mb-0">
  <span>{{ $t('footer.copyright') }}</span> 
 
  <a href="https://geeltech.com/" target="_blank" class="font-bold hover:text-teal-600 transition-colors duration-200">
    {{ $i18n.locale === 'ar' ? '  جيل تك,': ' Geel Tech' }}
  </a>
  {{ new Date().getFullYear() }}
  <!-- <span class="text-indigo-100">. {{ $t('footer.rightsSuffix') }}</span> -->
</div>


        <!-- Social Icons (Bottom) -->
        <div class="flex flex-row space-x-4 rtl:space-x-reverse text-xl">
          <template v-for="(link, name) in socialLinks" :key="'bottom-' + name">
            <a :href="link" target="_blank" class="hover:text-teal-300 transition-colors duration-200">
              <i :class="getIconClass(name)"></i>
            </a>
          </template>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import api from '@/api'

const socialLinks = ref({})

// helper to get icon classes
const getIconClass = (name) => {
  const lower = name.toLowerCase()
  if (lower === 'facebook') return 'fab fa-facebook-f'
  if (lower === 'instagram') return 'fab fa-instagram'
  if (lower === 'x' || lower === 'twitter') return 'fab fa-x-twitter' // change from Twitter to X
  if (lower === 'linkedin') return 'fab fa-linkedin-in'
  return 'fas fa-globe' // fallback icon
}

onMounted(() => {
  api.get('/v1/social-media-links')
    .then(res => {
      const unique = {}
      res.data.forEach(item => {
        const name = item.name.trim()
        if (!unique[name]) {
          unique[name] = item.link
        }
      })
      socialLinks.value = unique
    })
    .catch(err => {
      console.error("Failed to load social links:", err)
    })
})
</script>

<style scoped>
/* Ensure icons are displayed properly if needed */
</style>
